import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const MembershipExpired = () => {
  const navigate = useNavigate()

  const onClick = () => navigate("/payments")

  return (
    <>
      <h1 className="mb-4 fs-2 fw-semibold text-danger">Membership Expired</h1>
      <p className='m-0'>Your membership is no longer valid.</p>
      <p className='mb-4'>Please renew now to reactivate your account.</p>
      <Button
        className="mt-2 px-5 rounded-3"
        variant="dark"
        onClick={onClick}
      >
        Click to renew
      </Button>
    </>
  )
}

export default MembershipExpired